import { render, staticRenderFns } from "./DataFrom.vue?vue&type=template&id=f0372454&scoped=true&"
import script from "./DataFrom.vue?vue&type=script&lang=js&"
export * from "./DataFrom.vue?vue&type=script&lang=js&"
import style0 from "./DataFrom.vue?vue&type=style&index=0&id=f0372454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0372454",
  null
  
)

export default component.exports